import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SimulationSummaryComponent } from "src/pages/coaching/components/simulation/view";
import EmptyMessage from "src/components/emptyMessage";

import { fetchPublicSimulation } from "src/redux/actions/coaching/simulation";
import { SimulationContent } from "src/types/coaching/courses";
import { SimulationContext, SimulationContextProps } from "src/pages/coaching/components/simulation/view/context";

import _ from "lodash";
import styles from "./simulation.module.scss";

interface EditSimulationContentProps {
  course: SimulationContent;
}

export const EditSimulationContent = ({ course }: EditSimulationContentProps) => {

  const dispatch = useDispatch();
  const id = course?.content?.id;

  const simulation = useSelector((state: any) =>
    _.get(state.coaching, `simulations.simulation[${id}].item`),
  );

  const loading = useSelector((state: any) =>
    _.get(state.coaching, `simulations.simulation[${id}].loading`),
  );

  const [publicCourse, setPublicCourse] = useState({
    simulation: null,
  });

  const [simulationContext, setSimulationContext] =
    React.useState<SimulationContextProps>({
      id,
      view: "summary",
    });


  useEffect(() => {
    if (id && !simulation) {
      dispatch(fetchPublicSimulation({ id: id }));
    }
  }, [id]);

  useEffect(() => {
    if (simulation) {
      setPublicCourse((prev) => {
        return {
          ...prev,
          simulation: {
            ...simulation,
            id: simulation.id!,
            simulation: simulation,
            session: null,
            status: "ENROLLED",
          },
        };
      });
    }
  }, [simulation]);

  if (!loading && !simulation) {
    return (
      <div className={styles.notFoundContainer}>
        <EmptyMessage
          width={500}
          image="/images/assets/404error_message.svg"
          heading="Mmm... who moved my cheese?"
          message="Sorry! Someone passed you the wrong information. You were never supposed to see me :). This podcast does not exist any longer."
        />
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.loading}>
        <img src="/images/loading_plane.gif" />
        <div className={styles.message}>Loading simulation...</div>
      </div>
    );
  }

  return (
    <SimulationContext.Provider value={simulationContext}>
      {publicCourse.simulation && (
        <SimulationSummaryComponent simulation={publicCourse.simulation} className={styles.simulationView} />
      )}
    </SimulationContext.Provider>
  );
};
